/* ============================================================================
 *  siteConfig.js — AMIBFigura4
 *  Certificación AMIB Figura 4 — Asesor en Estrategias de Inversión (México)
 * ============================================================================ */

export const siteConfig = {
  saasKey: "amib-figura4",
  brand: {
    name: "AMIBFigura4",
    namePrefix: "AMIB",
    nameSuffix: "Figura4",
    subBrand: "by MIVX",
    tagline: "Preparación completa para el examen AMIB Figura 4 — Asesor en Estrategias de Inversión.",
    flagEmoji: "🇲🇽",
    madeInLabel: "Hecho en México",
    locale: "es-MX",
    timezone: "America/Mexico_City",
  },

  niche: {
    professionLabel: "Asesor en Estrategias de Inversión",
    aspirantLabel: "Aspirante a Asesor en Estrategias de Inversión",
    country: "México",
    authority: "AMIB / CNBV",
    phonePlaceholder: "+52 55 0000 0000",
    flagshipLaw: "Figura 4 — Programa Oficial de Certificación AMIB",
  },

  contact: {
    supportEmail: "go@mivx.com",
    salesEmail: "go@mivx.com",
  },

  payment: {
    // Lien de paiement Stripe (prod_UgBRZIzefGMCnA, MX$249/mes)
    checkoutUrl: "https://buy.stripe.com/14AeVcdk08MFfvMbtx0co06",
    portalUrl: "",
    cancelSubscriptionEndpoint:
      "https://ssulldqbxelavhyptweu.supabase.co/functions/v1/cancelar-suscripcion",
    providerName: "Stripe",
  },

  api: {
    geminiModel: "gemini-2.5-flash-preview-09-2025",
    aiErrorFallback:
      "No se pudo conectar con el Tutor IA. Por favor, intenta más tarde.",
  },

  seo: {
    title: "AMIBFigura4 — Simulador del Examen AMIB Figura 4 · Asesor en Estrategias de Inversión",
    description: "Aprueba el examen AMIB Figura 4 (Asesor en Estrategias de Inversión) con simulador tipo examen oficial, banco de +2,000 preguntas y explicación detallada en cada pregunta. Domina asset allocation, derivados, valuación y normativa CNBV.",
    keywords: "examen amib figura 4, asesor en estrategias de inversion, certificacion amib figura 4, simulador amib, asesor de inversiones mexico, mas amib, suitability cnbv",
    author: "AMIBFigura4",
    domain: "examenfigura4.com",
    canonicalUrl: "https://examenfigura4.com/",
    ogImage: "/og-image.png",
    ogTitle: "AMIBFigura4 — Simulador del Examen AMIB Figura 4 · Asesor en Estrategias de Inversión",
    ogDescription: "Aprueba el examen AMIB Figura 4 (Asesor en Estrategias de Inversión) con simulador tipo examen oficial, banco de +2,000 preguntas y explicación detallada en cada pregunta. Domina asset allocation, derivados, valuación y normativa CNBV.",
    schemaCourseName: "Curso de Preparación AMIB Figura 4 — Asesor en Estrategias de Inversión",
    schemaCourseDescription: "Simulador interactivo, temario completo y explicaciones detalladas para el examen oficial de Asesor en Estrategias de Inversión (AMIB Figura 4).",
  },

  colors: {
    primary: "#7c3aed",
    primaryDark: "#6d28d9",
    accent: "#a855f7",
    primaryTw: "violet-600",
    primaryTwHover: "violet-700",
    primaryTwLight: "violet-50",
    primaryTwBorder: "violet-200",
    primaryTwText: "violet-700",
    secondaryTw: "purple-600",
    secondaryTwLight: "purple-50",
    accentTw: "purple-500",
    gradientFrom: "from-violet-600",
    gradientTo: "to-purple-700",
  },

  stats: [
    { value: "+2,000", label: "Reactivos de práctica" },
    { value: "10", label: "Módulos del temario oficial" },
    { value: "100%", label: "Reactivos con explicación detallada" },
    { value: "24/7", label: "Disponible desde cualquier dispositivo" },
  ],

  hero: {
    badge: "Simulador tipo examen oficial",
    titleLine1: "Aprueba el examen y conviértete en",
    titleLine2: "Asesor en Estrategias de Inversión",
    subtitle: "Prepara el examen AMIB Figura 4: domina asset allocation, valuación de instrumentos, derivados, MAS y normativa CNBV con +2,000 reactivos y explicación detallada en cada pregunta.",
    primaryCta: "Comienza gratis",
    secondaryCta: "Hacer examen de prueba",
    secondaryCtaBadge: "Gratis",
  },

  features: {
    sectionEyebrow: "Características",
    sectionTitle: "Todo lo que necesitas para aprobar tu examen",
    sectionSubtitle:
      "Plataforma construida exclusivamente para el examen de Asesor en Estrategias de Inversión, con el contenido exacto del temario oficial AMIB Figura 4.",
    items: [
      {
        title: "Temario Oficial Figura 4",
        description: "Acceso completo al temario AMIB Figura 4: ética, productos, valuación, riesgos, portafolios, MAS y cumplimiento.",
        color: "from-violet-500 to-purple-500",
        iconPath: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
      },
      {
        title: "Simulador Real",
        description: "Examen con el formato y dificultad oficial de Figura 4, con temporizador y resultados instantáneos.",
        color: "from-emerald-500 to-teal-500",
        iconPath: "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
      },
      {
        title: "Práctica por Módulo",
        description: "Estudia tema por tema (derivados, portafolios, valuación, MAS…) e identifica tus puntos débiles.",
        color: "from-fuchsia-500 to-purple-500",
        iconPath: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
      },
      {
        title: "Explicaciones Detalladas",
        description: "Resuelve dudas con explicaciones claras tras cada respuesta, citando la LMV, CUFV y disposiciones CNBV aplicables.",
        color: "from-purple-500 to-pink-500",
        iconPath: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z",
      },
      {
        title: "Estadísticas Avanzadas",
        description: "Seguimiento de progreso, fortalezas y áreas de mejora por módulo del temario Figura 4.",
        color: "from-orange-500 to-red-500",
        iconPath: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
      },
      {
        title: "Actualización Constante",
        description: "Contenido actualizado con disposiciones recientes de la CNBV, AMIB y prácticas de mercado.",
        color: "from-green-500 to-emerald-500",
        iconPath: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
      },
    ],
  },

  demo: {
    sectionEyebrow: "Ponte a prueba hoy",
    sectionTitlePart1: "Simulador Real del",
    sectionTitlePart2: "Examen AMIB Figura 4",
    sectionSubtitle:
      "Experimenta el formato del examen oficial de Asesor en Estrategias de Inversión. Sin registros ni tarjetas.",
    bullets: [
      { label: "Reactivos Reales", icon: "📈" },
      { label: "Cronómetro", icon: "⏱️" },
      { label: "Calificación Instantánea", icon: "📊" },
      { label: "Explicación Detallada", icon: "💡" },
    ],
    ctaLabel: "Hacer examen de prueba",
    ctaBadge: "¡GRATIS!",
    questions: [
      {
        q: "¿Qué autoridad regula y supervisa la actividad del Asesor en Estrategias de Inversión en México?",
        o: ["Banxico", "CNBV", "SHCP", "CONDUSEF"],
        c: 1,
        exp: "La CNBV regula y supervisa a los Asesores en Estrategias de Inversión conforme a la Ley del Mercado de Valores.",
      },
      {
        q: "Si la duración modificada de un bono es 5 y la tasa sube 100 pb, el precio aproximadamente:",
        o: ["Sube 5%", "Baja 5%", "Sube 0.5%", "No cambia"],
        c: 1,
        exp: "ΔP/P ≈ −DM × Δy = −5 × 0.01 = −5%. El precio cae aproximadamente 5%.",
      },
      {
        q: "El Sharpe Ratio de un portafolio se calcula como:",
        o: ["(Rp − Rf) / σp", "Rp / βp", "(Rp − Rf) / βp", "σp / Rp"],
        c: 0,
        exp: "El Sharpe mide exceso de retorno por unidad de riesgo total (desviación estándar).",
      },
    ],
  },

  pricing: {
    eyebrowTitle1: "Un solo precio",
    eyebrowTitle2: "Acceso total",
    eyebrowSubtitle:
      "Sin planes confusos. Acceso completo al simulador, temario y explicaciones detalladas.",
    plan: {
      name: "Plan Examen Aprobado",
      price: 249,
      currency: "MX$",
      period: "/mes",
      description: "Todo el contenido y herramientas de estudio incluidas.",
      features: [
        "Temario Figura 4 completo y actualizado",
        "+2,000 reactivos de práctica",
        "Simulador tipo examen oficial ilimitado",
        "Explicación detallada en cada pregunta",
        "Análisis de progreso por módulo",
        "Soporte prioritario",
      ],
      ctaLabel: "Suscribirme Ahora",
      benefitsList: [
        "Simulador tipo examen oficial Figura 4",
        "Simulacros ilimitados",
        "+2,000 reactivos de práctica",
        "Explicación detallada en cada pregunta",
        "Acceso multi-dispositivo",
        "Temario oficial completo",
        "Análisis de progreso",
        "Soporte prioritario",
      ],
    },
  },

  faq: {
    eyebrow: "Preguntas Frecuentes",
    title: "Todo lo que necesitas saber",
    subtitle: "Respuestas a las dudas más comunes sobre AMIBFigura4.",
    items: [
      {
        question: "¿Necesito experiencia previa en mercados financieros?",
        answer:
          "No es indispensable. AMIBFigura4 está diseñado para llevarte paso a paso por todo el temario, desde fundamentos hasta valuación avanzada y MAS.",
      },
      {
        question: "¿El contenido está actualizado con la normativa vigente?",
        answer:
          "Sí. Actualizamos el banco de reactivos y temario con las últimas disposiciones de AMIB y CNBV, incluyendo MAS, DUF y reglas de suitability.",
      },
      {
        question: "¿Puedo cancelar la suscripción cuando quiera?",
        answer:
          "Sí, puedes cancelar en cualquier momento. Sin contratos ni permanencia. Al cancelar, mantienes tu acceso premium hasta el final del período ya pagado.",
      },
      {
        question: "¿El simulador replica el examen real?",
        answer:
          "Sí. Reproducimos el formato del examen oficial Figura 4 con el mismo tipo de reactivo, ponderación por módulo y nivel de dificultad.",
      },
      {
        question: "¿Esta plataforma me da la certificación oficial?",
        answer:
          "No. Te prepara para aprobar. La certificación oficial de Asesor en Estrategias de Inversión la emite AMIB tras aprobar el examen Figura 4.",
      },
      {
        question: "¿Puedo estudiar desde mi celular?",
        answer:
          "Sí. La plataforma es 100% responsive: estudia desde computadora, tablet o smartphone.",
      },
      {
        question: "¿Cuánto tiempo necesito para prepararme?",
        answer:
          "Recomendamos 6-12 semanas dedicando 1-2 horas diarias, dependiendo de tu base previa en mercados, derivados y portafolios.",
      },
    ],
  },

  testimonials: {
    eyebrow: "La plataforma",
    title: "Lo que incluye la plataforma",
    subtitle: "Herramientas concretas para preparar el examen AMIB Figura 4.",
    items: [
      {
        icon: "📚",
        title: "+2,000 preguntas con explicación",
        description:
          "Banco de reactivos alineado al temario oficial Figura 4, cada uno con su explicación detallada.",
      },
      {
        icon: "📝",
        title: "Simulacros tipo examen oficial ilimitados",
        description:
          "Practica con el formato, la ponderación por módulo y el cronómetro del examen real, tantas veces como quieras.",
      },
      {
        icon: "📊",
        title: "Estadísticas y seguimiento de progreso",
        description:
          "Visualiza tu avance por módulo del temario e identifica tus áreas de mejora.",
      },
      {
        icon: "💻",
        title: "Acceso 24/7 en cualquier dispositivo",
        description:
          "Estudia desde computadora, tablet o smartphone, a la hora que mejor te convenga.",
      },
    ],
  },

  ai: {
    chatTitle: "Tutor Inteligente AMIB Figura 4",
    welcomeMessage: "¡Hola! Soy tu tutor experto en la Figura 4 AMIB. ¿Tienes dudas sobre asset allocation, valuación de derivados, MAS, suitability o normativa CNBV? Pregúntame.",
    systemInstructionDefault: "Eres un experto en regulación CNBV y certificación AMIB Figura 4 para Asesores en Estrategias de Inversión.",
    systemInstructionTutor: "Eres un tutor experto en el examen AMIB Figura 4 (Asesor en Estrategias de Inversión). Sé directo y cita LMV, DUF y disposiciones CNBV cuando sea relevante.",
    casePromptTemplate: (topicTitle) =>
      `Genera un caso práctico corto (máx 100 palabras) sobre "${topicTitle}" para un Asesor en Estrategias de Inversión en México. Incluye un dilema de suitability, conflicto de interés o decisión técnica, y pregunta qué debería hacer.`,
    caseSystemInstruction: "Eres un instructor de la AMIB en México especializado en Figura 4.",
    inputPlaceholder: "Escribe tu duda regulatoria o técnica...",
  },

  exam: {
    simulatorQuestions: 80,
    simulatorDurationMinutes: 120,
    topicWeights: [
      { id: "t1", weight: 0.12 },
      { id: "t2", weight: 0.12 },
      { id: "t3", weight: 0.10 },
      { id: "t4", weight: 0.10 },
      { id: "t5", weight: 0.08 },
      { id: "t6", weight: 0.08 },
      { id: "t7", weight: 0.12 },
      { id: "t8", weight: 0.10 },
      { id: "t9", weight: 0.10 },
      { id: "t10", weight: 0.08 },
    ],
    passingScore: 70,
    simulatorTitle: "Simulación Real Figura 4",
  },

  uiCopy: {
    loading: "Cargando...",
    navHome: "Dashboard",
    navStudy: "Temario Figura 4",
    navStudyShort: "Temario Oficial",
    navQuizzes: "Práctica por temas",
    navQuizzesShort: "Práctica por Tema",
    navSimulator: "Simulador Real",
    navBilling: "Mi Plan",
    sidebarPrincipal: "Principal",
    sidebarSimulation: "Simulación",
    bannerCta: "🚀 Desbloquea el Simulador Real y Práctica por Temas",
    bannerCtaButton: "Premium",
    legalLastUpdate: "Última actualización: 10 de junio de 2026",
    cta: {
      finalSectionTitle: "¿Listo para aprobar tu Figura 4?",
      finalSectionSubtitle: "Prepara el examen AMIB Figura 4 con simulador tipo examen oficial y +2,000 reactivos con explicación. ¡Comienza hoy!",
      finalSectionPrimary: "Comenzar ahora",
      finalSectionSecondary: "Hablar con ventas",
      finalSectionFooter: "✨ Acceso inmediato · Cancela cuando quieras",
    },
    masterDomainLabel: "Dominio del Temario Oficial",
    statsCards: {
      generalProgress: "Progreso General",
      sectionsRead: "Secciones Leídas",
      examsTaken: "Simulacros Realizados",
      bestScore: "Puntaje Máx.",
    },
    auth: {
      welcomeTitle: "Bienvenido",
      welcomeSubtitle: "Inicia sesión para continuar tu certificación",
      registerTitle: "Crear cuenta",
      registerSubtitle: "Comienza tu camino a la Figura 4",
    },
    landing: {
      productNavLabel: "Producto",
      productLinks: [
        { href: "#features", label: "Características" },
        { href: "#pricing", label: "Precios" },
        { href: "#demo", label: "Simulador" },
        { href: "#incluye", label: "Qué incluye" },
      ],
    },
  },

  legal: {
    companyName: "AMIBFigura4 by MIVX",
    companyShortName: "AMIBFigura4",
    governingLaw: "México",
    privacyContactEmail: "go@mivx.com",
  },
};

export default siteConfig;
